import React, { useState, useEffect } from "react";
import { Container, } from 'reactstrap';
import Layout from "../../HorizontalMenu/Menu";
import Navbar from "../../HorizontalMenu/Navbar";
import '../../global/GlobalCSS.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../';
import { VesselState, setVesselState } from "../../Store/Generic/ReportingSlice";
import { useQuery } from "react-query";
import { queryKeyes } from "../../shared/queryKeys";
import { DeckReportTabsConstant, EventPrecedence, ReportingTypeConstant } from "../../shared/constants";
import { Get } from "../../VesselMaster/vesselMaster.hooks";
import DeckOfficerReportingStructure from "./DeckOfficerReportingStructure";
import ErrorComponent from "Components/ErrorComponent";
import FormLoading from "Components/FormLoading";
import { useEditReport } from "VesselReportingInfo/EditCompletedReports/EditReportProvider";

const DeckOfficerWizard = () => {
    const { editReportBool, deckActiveTabBool, setDeckActiveTab, tabsIdListDeck, setActiveAddLfondsTab, setPreviousDeckTabIndex } = useEditReport();
    /** State variables start */
    const { VesselID, CurrentReport, reportingLoading, reportingError } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState<any>()
    const [filteredCIIEventsList, setFilteredCIIEventsList] = useState<Array<{ [key: string]: string | number | Date | boolean }>>([]);
    /** State variables end */

    /** Queries */
    /** get CII adjustment Vessel Reporting */
    const {
        data: CIIAdjustmentEvents,
        isLoading: CIIAdjustmentEventsLoading,
        isError: CIIAdjustmentEventsError,
    } = useQuery(
        [queryKeyes.vessel.VesselReportingCIIAdjusment.key, VesselID],
        async () => {
            return await Get(queryKeyes.vessel.VesselReportingCIIAdjusment.url(VesselID), VesselID);
        },
        { staleTime: Infinity }
    );
    /** Queries end */

    /** UseEffect */
    /** filter CIIEvents */
    useEffect(() => {
        if (CIIAdjustmentEventsError || !CIIAdjustmentEvents || CIIAdjustmentEvents.length === 0) {
            setFilteredCIIEventsList([]);
            return;
        }
        const filtered = CIIAdjustmentEvents.filter(
            (item: { [key: string]: string | number | Date | boolean }) =>
                item.cii_begin_date_time <= currentVesselReport?.local_time &&
                (item.cii_end_date_time >= currentVesselReport?.local_time || !item.cii_end_date_time)
        );
        setFilteredCIIEventsList(filtered);
    }, [CIIAdjustmentEvents, CIIAdjustmentEventsError, currentVesselReport]);
    /** Set Remark tab id as active tab id in edit wizard */
    useEffect(() => {
        if (deckActiveTabBool) {
            setDeckActiveTab(DeckReportTabsConstant.RemarksId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deckActiveTabBool]);
    useEffect(() => {
        if (!editReportBool) {
            setDeckActiveTab(DeckReportTabsConstant.WeatherDataId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editReportBool])
    /** useEffect end */

    /** Set vessel state globally */
    const handleVesselState = (record: VesselState) => {
        dispatch(setVesselState(record))
    }

    /** Function to change optional tabs */
    const toggleDynamicTabs = (tab: any) => {
        setPreviousDeckTabIndex(tab);
        setDeckActiveTab(tabsIdListDeck[tab]);
    }

    /** Change Lfonds' additional info tabs */
    const toggleAddLfondsTab = (tab: number) => {
        if (tab >= 1 && tab <= (currentVesselReport && currentVesselReport?.reporting_type === ReportingTypeConstant.ATSEA ? 1 :
            ((currentVesselReport?.event_precedence_id === EventPrecedence.DROP_ANCHOR) ||
                (currentVesselReport?.event_precedence_id === EventPrecedence.HEAVE_ANCHOR)) ? 5 :
                ((currentVesselReport?.event_precedence_id === EventPrecedence.DEPARTURE_FROM_BERTH) ||
                    (currentVesselReport?.event_precedence_id === EventPrecedence.DEPARTURE_FROM_DRIFTING_PORT)) ? 4 : 3)) {
            setActiveAddLfondsTab(tab);
        }
    }

    return (
        <React.Fragment>
            {!editReportBool ?
                <React.Fragment>
                    <Layout>
                        <Navbar />
                    </Layout>
                    <div className="page-content">
                        <Container fluid>
                            {(reportingLoading || CIIAdjustmentEventsLoading) && <FormLoading />}
                            {reportingError && <ErrorComponent message="Error loading required data!" />}
                            {!(reportingLoading || CIIAdjustmentEventsLoading) &&
                                !reportingError &&
                                <DeckOfficerReportingStructure
                                    handleVesselState={handleVesselState}
                                    CIIAdjustmentEventsLoading={CIIAdjustmentEventsLoading}
                                    toggleTab={toggleDynamicTabs}
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    filteredCIIEventsList={filteredCIIEventsList}
                                    toggleAddLfondsTab={toggleAddLfondsTab}
                                />
                            }
                        </Container>
                    </div>
                </React.Fragment> :
                <React.Fragment>
                    {(reportingLoading || CIIAdjustmentEventsLoading) && <FormLoading />}
                    {reportingError && <ErrorComponent message="Error loading required data!" />}
                    {!(reportingLoading || CIIAdjustmentEventsLoading) &&
                        !reportingError &&
                        <DeckOfficerReportingStructure
                            handleVesselState={handleVesselState}
                            CIIAdjustmentEventsLoading={CIIAdjustmentEventsLoading}
                            toggleTab={toggleDynamicTabs}
                            errorMessage={errorMessage}
                            setErrorMessage={setErrorMessage}
                            filteredCIIEventsList={filteredCIIEventsList}
                            toggleAddLfondsTab={toggleAddLfondsTab}
                        />
                    }
                </React.Fragment>
            }
        </React.Fragment >
    );
};

export default DeckOfficerWizard;
